import { toast } from "react-toastify";
import api from "../../services/api.jsx";
import download from "downloadjs";
import moment from "moment";
import  { CopyToClipboard } from "react-copy-to-clipboard";
import { useState } from "react";
import "./ItemBoleto.css";
import { QRCodeSVG } from "qrcode.react";
import ModalQrCodePix from "../ModalQrCodePIX/ModalQrCodePIX.jsx";

function ItemBoleto (props) {

    const [value, setValue] = useState (props.codbarra);
    const [copied, setCopied] = useState(false);
    const [QrCodePix, SetQrCodePix] = useState({});
    const [isItemOpen, setisItemOpen] = useState(false);

    function BoletoError(err, id) {
        // Proteção contra erros caso a estrutura do erro não exista
        const codigoErro = err.response?.data?.erros?.[0]?.codigo || "desconhecido";
      
        // Mapeia os códigos de erro para as mensagens correspondentes
        const mensagensErro = {
          "4432632": "Boleto em atraso, não é possível gerar PIX. Copie o código de barras ou imprima o boleto.",
          "4678420": "Boleto indisponivel para pagamento via.",
          "6197696": "Boleto fora do prazo limite de pagamento. Entre em contato com o setor de cobrança.",
        };
      
        // Obtém a mensagem correspondente ou usa uma mensagem padrão dinâmica
        const mensagem = mensagensErro[codigoErro] || `Não foi prossivel registra o boleto (Código: ${codigoErro})`;
      
        // Atualiza o toast
        toast.update(id, {
          render: mensagem,
          type: "error",
          isLoading: false,
          autoClose: 8000,
        });
      }

    function GerarQrCode(nossonumero) {
        const id = toast.loading("Processando Boleto ...", {position : toast.POSITION.TOP_CENTER})

   
        api.get('/boletos/ConsultarBoleto/' + nossonumero)
            .then((retorno) => {      
                
                
                console.log(retorno.data);

                if (retorno.status == 200){

                    toast.update(id, {render: "Consultando PIX !"});                     
                    api.get('/boletos/ConsultarPIX/' + nossonumero)
                    .then((retorno) =>{
                                                
                        console.log(retorno.data["qrCode.emv"])   
                        SetQrCodePix(retorno.data["qrCode.emv"]); 
                        setisItemOpen(true);   
                        
                        toast.update(id, {
                            render: "Pix consultado com Sucesso !", 
                            type: "success", 
                            isLoading: false,                             
                           autoClose: 2000}); 

                    })
                    .catch((err) =>{
                        
                        toast.update(id, {render: "Processando PIX !"}); 
                        api.get('/boletos/GerarPIX/' + nossonumero)
                        .then((retorno) =>{
                            console.log(retorno.data["qrCode.emv"])  
                            SetQrCodePix(retorno.data["qrCode.emv"]); 
                            setisItemOpen(true); 

                            toast.update(id, {
                                render: "Pix Processado com Sucesso !", 
                                type: "success", 
                                isLoading: false,                             
                               autoClose: 2000}); 
                        })
                        .catch((err) =>{

                            
                            BoletoError(err, id);                           
                            console.log(err.response.data.erros[0]);

                            
                        })
                        
                        

                    })

                }                                                               
               

            })
            .catch((err) => {
    
                toast.update(id, {render: "Registrando Boleto e PIX !"}); 
                api.get('/boletos/RegistrarBoletoPix/' + nossonumero)
                .then((retorno) =>{

                    SetQrCodePix(retorno.data.qrCode.emv); 
                    setisItemOpen(true); 

                    toast.update(id, {
                        render: "PIX Processado com Sucesso !", 
                        type: "success", 
                        isLoading: false,                             
                       autoClose: 2000}); 

                })
                .catch((err) =>{

                    BoletoError(err, id);   
                    console.log( err.response.data.erros[0]);

                })
                
                
        }); 

    }


    function closeModalItem(){
        setisItemOpen(false);
    } 
    
    function DownloadPDF(nossonumero) {   

   
        const id = toast.loading("Processando Boleto", {position : toast.POSITION.TOP_CENTER})

        api.get('/boletos/ConsultarBoleto/' + nossonumero)
            .then((retorno) => {      
                                        
                    toast.update(id, {render: "Gerando PDF"});   
                   
                    /*Download PDF*/
                    api
                    .get("/boletos/download/"+nossonumero, {            
                        responseType: 'blob',                 
                    })
                    .then(response => {
        
                        toast.update(id, {
                                     render: "Boleto gerado com sucesso", 
                                     type: "success", 
                                     isLoading: false,                             
                                    autoClose: 2000});
        
                        const content = response.data['blob'];
                        download(response.data, nossonumero+'.PDF', content)
                    })
                    .catch( (error) => {
        
                        toast.update(id, {
                                     render: "Erro ao gerar boleto", 
                                     type: "erro", 
                                     isLoading: false,
                                     autoClose: 2000});
        
                    });

            })
            .catch((err) => {
    
                toast.update(id, {render: "Registrando Boleto e PIX"}); 
                api.get('/boletos/RegistrarBoletoPix/' + nossonumero)
                .then((retorno) =>{

                    toast.update(id, {render: "Gerando PDF !"});  
                    /*Download PDF*/
                    api
                    .get("/boletos/download/"+nossonumero, {            
                        responseType: 'blob',                 
                    })
                    .then(response => {
        
                        toast.update(id, {
                                     render: "Boleto gerado com sucesso", 
                                     type: "success", 
                                     isLoading: false,                             
                                    autoClose: 2000});
        
                        const content = response.data['blob'];
                        download(response.data, nossonumero+'.PDF', content)
                    })
                    .catch( (error) => {
        
                        toast.update(id, {
                                     render: "Erro no gerar boleto", 
                                     type: "erro", 
                                     isLoading: false,
                                     autoClose: 2000});
        
                    });

                })
                .catch((err) =>{

                    BoletoError(err, id);   
                    console.log( err.response.data.erros[0]);

                })
                
                
        });                   


    }

    function registrarBoleto(nossonumero){
        const id = toast.loading("Processando Boleto ...", {position : toast.POSITION.TOP_CENTER})

   
        api.get('/boletos/ConsultarBoleto/' + nossonumero)
            .then((retorno) => {      
                                        
                toast.update(id, {
                    render: "Boleto registrado com Sucesso !", 
                    type: "success", 
                    isLoading: false,                             
                    autoClose: 2000});                                                       

            })
            .catch((err) => {
    
                toast.update(id, {render: "Registrando Boleto e PIX !"}); 
                api.get('/boletos/RegistrarBoletoPix/' + nossonumero)
                .then((retorno) =>{

                    toast.update(id, {
                        render: "Boleto registrado com Sucesso !", 
                        type: "success", 
                        isLoading: false,                             
                       autoClose: 2000}); 

                })
                .catch((err) =>{

                    BoletoError(err, id);   
                    console.log( err.response.data.erros[0]);

                })
                
                
        }); 

    }
    
    

    return <>

           
           <ModalQrCodePix isOpen={isItemOpen}
                            onRequestClose={closeModalItem} 
                            QrCodePix={QrCodePix}
                            />


            <div className="list-group">

            <a className="list-group-item list-group-item-action flex-column align-items-start mb-3">
                
                <div className="row">
                    <label className="text-center mb-1">BOLETO</label>                    
                    <hr/>
                </div>

                <div className="d-flex w-100 justify-content-between">
                <p className="mb-1 label-Principal">{props.cliente}</p>                
                </div>

                <div className="d-flex flex-column mb-2">
                
                
                <small className="mb-1">Nº: {props.nossonumero}</small>
                <small className="mb-1">Nota Fiscal: {props.notafiscal}</small>
                <small className="mb-1">Parcela: {props.prest}</small>  
                <small className="mb-1 label-valor">{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(props.valor)}</small>                        
                 
                <div className="d-flex w-100 justify-content-between">                        
                    <small className="mb-1 label-valor">Vencimento: {moment(props.datavencimento).utc().format('DD/MM/YYYY')}</small>                             
                    <small className="mb-1 label-valor">{props.atrazo > 0 ? <div><small className="mb-1 atrazo">DIAS DE ATRASO: {props.atrazo}</small></div>: null}</small>
                </div>        
                       
                </div>
                
                <div className="row">
                
                <div className="col-md-2 d-flex flex-column p-0">
                <CopyToClipboard text={value} onCopy={() => setCopied(true)}>
                        <button onClick={() => registrarBoleto(props.nossonumero)} className="btn btn-primary  bi bi-copy m-1 h-100"> Codigo de Barras</button>
                </CopyToClipboard>
                </div>
                
                <div className="col-md-2 d-flex flex-column p-0">
                <button onClick={() => DownloadPDF(props.nossonumero)} className="btn btn-primary  bi bi-filetype-pdf m-1 h-100"> Baixar PDF</button>
                </div>

                <div className="col-md-2 d-flex flex-column p-0">
                <button onClick={() => GerarQrCode(props.nossonumero)} className="btn btn-primary m-1 h-100">Paga via PIX</button>
                </div>

                </div>  

            </a>

            </div>                     
            </>
}

export default ItemBoleto;  